export enum CanvasMode {
    View = "VIEW",
    Edit = "EDIT",
}
